const MAX_REVIEWS_PER_SKU = 10;

export const SentimentSchema = {
  type: 'object',
  properties: {
    reviewSentiments: {
      type: 'object',
      properties: {
        BrandName: {
          type: 'string',
          minLength: 1,
        },
        AverageBrandRating: {
          type: 'number',
          minimum: 0,
          maximum: 5,
        },
        TotalReviewCount: {
          type: 'integer',
          minimum: 1,
        },
      },
      required: ['BrandName', 'AverageBrandRating', 'TotalReviewCount']
    }
  },
  required: ['reviewSentiments']
};

export const ReviewSchema = {
  type: 'object',
  properties: {
    reviews: {
      type: 'object',
      properties: {
        TotalResults: {
          type: 'integer',
          maximum: MAX_REVIEWS_PER_SKU,
        },
      },
      required: ['TotalResults'],
    },
  },
  required: ['reviews'],
};
